import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GetRateHotkey from './get-rate';
import ReadWeightFromScaleHotkey from './read-weight-from-scale';
import CreateLabelHotkey from './create-label';
import { SellerPresetHotkeys } from '../../../components/hotkeys/seller-presets';
import { useFulfillmentPlannerCreateLabel } from '../../../fulfillment-planner/rate-and-create-label/use-fulfillment-planner-create-label';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';

export const OrderDetailsCanvasHotkeys = ({ fulfillmentPlanId, isReturnView = false }) => {
  const selectedFulfillmentPlanIds = useMemo(() => [fulfillmentPlanId], [fulfillmentPlanId]);
  const { applyPresetConfiguration } = useFulfillmentPlannerContext();

  const { isCreateLabelDisabled } = useFulfillmentPlannerCreateLabel();
  const shouldDisableCreateLabel = isCreateLabelDisabled || isReturnView;

  return (
    <>
      <SellerPresetHotkeys fulfillmentPlanIds={selectedFulfillmentPlanIds} onApplyPreset={applyPresetConfiguration} />
      <GetRateHotkey shouldOverrideInternalDisabledLogic={isReturnView} />
      <ReadWeightFromScaleHotkey selectedFulfillmentPlanIds={selectedFulfillmentPlanIds} />
      <CreateLabelHotkey disabled={shouldDisableCreateLabel} selectedFulfillmentPlanIds={selectedFulfillmentPlanIds} />
    </>
  );
};

OrderDetailsCanvasHotkeys.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  isReturnView: PropTypes.bool,
};
